export const COACH_COLUMN = 'COACH_COLUMN';
export const COACH_INDEX = 'COACH_INDEX';
export const COACH_LOADING_INDEX = 'COACH_LOADING_INDEX';
export const COACH_LOADING_SHOW = 'COACH_LOADING_SHOW';
export const COACH_OPTION = 'COACH_OPTION';
export const COACH_RESET = 'COACH_RESET';
export const COACH_SEARCH = 'COACH_SEARCH';
export const COACH_SHOW = 'COACH_SHOW';
